import * as React from "react";
const XCorp = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m5.037 5 5.79 7.722L5 19h1.312l5.102-5.497L15.537 19H20l-6.117-8.156L19.307 5h-1.311l-4.7 5.062L9.5 5H5.037Zm1.928.963h2.051l9.055 12.073h-2.05L6.964 5.963Z" }));
XCorp.displayName = "XCorp";
var XCorp_default = XCorp;
export {
  XCorp_default as default
};
